import { Link } from "react-router-dom";

/**
 * 3 info cards (hours, warranty, pricing) shown on the City Hub page.
 * - `cityName` : used to display "Horaires à {city}".
 */
export default function CityInfoCards({ cityName }) {
    return (
        <section className="max-w-7xl mx-auto px-5 lg:px-10 py-14">
            <div className="grid lg:grid-cols-3 gap-6">
                <div className="card-soft p-6">
                    <i className="fa-solid fa-clock text-[var(--amber)] text-2xl" />
                    <h3 className="heading text-lg font-bold mt-3">Horaires à {cityName}</h3>
                    <p className="mt-2 text-sm text-[var(--ink-soft)]">
                        Lundi au samedi, 8 h - 20 h. Urgences possibles le dimanche selon planning (majoration 25 %).
                    </p>
                </div>
                <div className="card-soft p-6">
                    <i className="fa-solid fa-shield-halved text-[var(--amber)] text-2xl" />
                    <h3 className="heading text-lg font-bold mt-3">Garantie 18 mois</h3>
                    <p className="mt-2 text-sm text-[var(--ink-soft)]">
                        Pièces et main-d&apos;œuvre. Si la même panne réapparaît dans le délai, nous revenons gratuitement.
                    </p>
                </div>
                <div className="card-soft p-6">
                    <i className="fa-solid fa-euro-sign text-[var(--amber)] text-2xl" />
                    <h3 className="heading text-lg font-bold mt-3">Tarifs transparents</h3>
                    <p className="mt-2 text-sm text-[var(--ink-soft)]">
                        Devis gratuit par téléphone, main-d&apos;œuvre forfaitaire dès 99 €.{" "}
                        <Link to="/tarifs" className="underline decoration-[var(--amber)] decoration-2 font-semibold">
                            Voir les tarifs
                        </Link>
                        .
                    </p>
                </div>
            </div>
        </section>
    );
}
